import { useQuery } from '@tanstack/react-query';
import * as Effect from 'effect/Effect';
import { pipe } from 'effect/Function';
import { GroupService } from '@/effects/groups/group.service';
import { MainLayer } from '@/effects/layers';
import { QUERY_KEYS } from '@/lib/constants';
import { runEffect } from '@/effects/runtime';

export function useCategoryBalances(groupId: string) {
  console.log('[useCategoryBalances] Called with groupId:', groupId);

  return useQuery({
    queryKey: [QUERY_KEYS.CATEGORY_BALANCES, groupId],
    queryFn: async () => {
      console.log('[useCategoryBalances] Fetching category balances for group:', groupId);
      const program = pipe(
        GroupService,
        Effect.flatMap((service) => service.fetchCategoryBalances(groupId)),
        Effect.provide(MainLayer)
      );

      const result = await runEffect(program);
      console.log('[useCategoryBalances] Result:', result);
      return result;
    },
    enabled: !!groupId,
    staleTime: 30_000, // 30 seconds
  });
}